<div
  class="ui-vertical-divider"
  [style.width]="width ?? '8px'"
  [style.background]="color ?? 'var(--bg-0)'"
></div>